import apiClient from '../../config/apiClient';

export type GiftStatus = 'pending' | 'active' | 'ended' | 'expired' | 'cancelled';
export interface AdGift {
  giftId: string;
  userId: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  status: string;
  displayStatus: GiftStatus;
  durationDays: number;
  selectedAt?: string;
  claimExpiresAt?: string;
  claimedAt?: string;
  expiresAt?: string;
  nextEligibleAt?: string;
  reason?: string;
}
export interface AdGiftFilters {
  email?: string;
  userId?: string;
  status?: GiftStatus | 'all' | 'claimed';
  startDate?: string;
  endDate?: string;
}
export interface AdGiftResult {
  docs: AdGift[];
  total: number;
  page: number;
  size: number;
  summary: Record<GiftStatus | 'total' | 'accounts' | 'claimed', number>;
  quota: { month: string; count: number; limit: number; nextAvailableAt: string | null };
  asOf: string;
}
export async function getAdGifts(params: AdGiftFilters & { page: number; size: number }): Promise<AdGiftResult> {
  const response = await apiClient.get('/admin/ad-gifts', { params });
  if (!response?.data?.success || !response.data.data) throw new Error(response?.data?.message || 'Không thể tải danh sách quà.');
  return response.data.data;
}
